import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from '@/components/Loading.vue';
import CardSet from '@/components/CardSet.vue';
import BackButton from '@/components/BackButton.vue';
const blobsModule = namespace('blobs');
let CustomizationOptions = class CustomizationOptions extends Vue {
    created() {
    }
    get customizationOptions() {
        return [
            {
                name: 'Class Improvements',
                to: 'customizationOptions/classImprovements'
            },
            {
                name: 'Fighting Styles',
                to: 'customizationOptions/fightingStyles'
            },
            {
                name: 'Fighting Masteries',
                to: 'customizationOptions/fightingMasteries'
            },
            {
                name: 'Lightsaber Forms',
                to: 'customizationOptions/lightsaberForms'
            },
            {
                name: 'Multiclass Improvements',
                to: 'customizationOptions/multiclassImprovements'
            },
            {
                name: 'Splashclass Improvements',
                to: 'customizationOptions/splashclassImprovements'
            },
            {
                name: 'Weapon Focuses',
                to: 'customizationOptions/weaponFocuses'
            },
            {
                name: 'Weapon Supremacies',
                to: 'customizationOptions/weaponSupremacies'
            }
        ];
    }
};
CustomizationOptions = __decorate([
    Component({
        components: {
            Loading,
            BackButton,
            CardSet
        }
    })
], CustomizationOptions);
export default CustomizationOptions;
